import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import PropTypes from 'prop-types';
import React from 'react';
import CardHeader from '@mui/material/CardHeader';

const ProfileInfoSection = ({children, title, disableBodyPadding}) => {
    return (
        <Card variant="outlined" sx={{marginBottom: 2}}>
            <CardHeader title={title} titleTypographyProps={{variant: 'h6', fontWeight: 'bold'}}/>
            <CardContent sx={{
                padding: disableBodyPadding ? 0 : 2,
                '&:last-child': { paddingBottom: disableBodyPadding ? 0 : 2 }
            }}
            >
                {children}
            </CardContent>
        </Card>
    );
};

ProfileInfoSection.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string.isRequired,
    disableBodyPadding: PropTypes.bool,
};

export default ProfileInfoSection;